export default {
  title: 'Mé objednávky',
  subtitle: 'Zobrazte si své aktivní klíče a předchozí nákupy.',

  // Empty state
  noOrdersTitle: 'Zatím žádné objednávky',
  noOrdersBody: 'Když si koupíte svůj první herní klíč, objeví se zde spolu s údaji o doručení.',
  browseCatalog: 'Procházet katalog',

  // Pending orders
  pendingOrders: 'Čekající objednávky',
  activeCount: '{count} aktivních',
  noPendingOrders: 'Žádné čekající objednávky.',
  purchasedOn: 'Zakoupeno dne {date}',
  statusDelivered: 'Doručeno',
  statusProcessing: 'Zpracovává se',
  showKey: 'Zobrazit klíč',
  revealing: 'Odkrývání…',
  revealed: 'Odkryto',
  keyNotReady: 'Klíč zatím není připraven — zkuste to prosím za chvíli.',
  keyNotAvailable: 'Klíč zatím není k dispozici.',
  howToActivate: 'Jak aktivovat',

  // Activation steps — Steam
  steamStep1: 'Spusťte Steam a přihlaste se ke svému účtu.',
  steamStep2: 'Klikněte na nabídku „Hry“ a poté na „Aktivovat produkt na Steamu“.',
  steamStep3: 'Postupujte podle pokynů a po vyzvání zadejte klíč.',
  // Activation steps — generic
  genericStep1: 'Otevřete oficiálního klienta / launcher.',
  genericStep2: 'Najděte „Aktivovat produkt“ nebo „Uplatnit kód“.',
  genericStep3: 'Po vyzvání zadejte svůj klíč.',

  // History
  orderHistory: 'Historie objednávek',
  colDate: 'Datum',
  colProduct: 'Produkt',
  colPrice: 'Cena',
  colStatus: 'Stav',
  colInvoice: 'Faktura',
  download: 'Stáhnout',
  notAvailable: 'Není k dispozici',
  noPastOrders: 'Zatím žádné předchozí objednávky.',
  browseTheCatalog: 'Procházejte katalog',
  noPastOrdersSuffix: 'a začněte.',
};
